export default class JobMetaClub {
    static fromDataAndDatevExport(data) {
        if (!data) {
            return;
        }

        let jobMetaClub = new JobMetaClub();
        jobMetaClub.jobId = data.jobId;
        jobMetaClub.bookingPeriod = data.bookingPeriod;
        jobMetaClub.invoicePeriodStart = data.invoicePeriodStart;
        jobMetaClub.invoicePeriodEnd = data.invoicePeriodEnd;

        Object.seal(jobMetaClub);
        return jobMetaClub;
    }
}
